import React, { useState } from 'react';
import Helmet from 'react-helmet';
import { Inertia } from '@inertiajs/inertia';
import { InertiaLink, usePage } from '@inertiajs/inertia-react';
import UserLayout from '../../Shared/UserLayout';
import DataContainer from '../../Shared/DataContainer';
import DropdownButton from '../../Shared/DropdownButton';
import Pagination from '../../Shared/Pagination';
import Icon from '../../Shared/Icon';
import { can } from '../../utils';

const ItemPurchased = () => {
     const { auth, errors, data } = usePage().props;
     console.log(data);
     const [values, setValues] = useState({});

     return (
          <React.Fragment key="security-index">
               <Helmet>
                    <title>Items Purchased</title>
               </Helmet>
               <div className="max-w-7xl mx-auto p-2">
                    <InertiaLink className="font-semibold text-md text-gray-700 hover:text-gray-800 leading-tight" href={route('home')}>Dashboard</InertiaLink> | <span className="text-md text-gray-700 leading-tight">Items Purchased</span>
               </div>
               {!data && (<div className="rounded col-span-12 bg-blue-100 text-blue-600 border border-blue-500 px-4 py-4 text-center">No Item has been purchased yet. Please head to the <InertiaLink className="font-bold" href={route('catalog.index')}>catalog</InertiaLink> to start purchasing.</div>)}
               {data && (<DataContainer>
                    <table className="table-fixed col-span-12">
                         <thead className="bg-gray-400">
                              <tr>
                                   <th className="px-4 py-2"></th>
                                   <th className="px-4 py-2">Name</th>
                                   <th className="px-4 py-2">Category</th>
                                   <th className="px-4 py-2">Type</th>
                                   {/*<th className="px-4 py-2"></th> */}
                              </tr>
                         </thead>
                         <tbody>
                              {data.data.map(({id, name, type, category, code, image, packs}) => {
                                   return <tr key={id}>
                                        <td className="border px-4 py-2 text-center">
                                             {image && (<img src={image} alt={name} className="w-8 rounded mx-auto" alt="Thumbnail" />)}
                                             {!image && (<img className="w-8 rounded mx-auto" src={`https://ui-avatars.com/api/?name=${name}&amp;color=7F9CF5&amp;background=EBF4FF`} alt={name} />)}
                                        </td>
                                        <td className="border px-4 py-2 text-center">{name} <span className="text-xs text-gray-500">({code})</span></td>
                                        <td className="border px-4 py-2 text-center">{category}</td>
                                        <td className="border px-4 py-2 text-center">{type}</td>
                                        {/* <td className="border px-4 py-2 text-center">
                                             <DropdownButton caption="Actions" color="blue">
                                                  <InertiaLink href={''} className="flex block px-6 py-2 text-gray-600 hover:bg-gray-100 hover:text-gray-700">
                                                       <Icon name={'eye'} className={'fill-current w-5 h-5 mr-2'} /> Do Whatever
                                                  </InertiaLink>
                                             </DropdownButton>
                                        </td> */}
                                   </tr>
                              })}
                         </tbody>
                    </table>
               </DataContainer>)}
          </React.Fragment>
     );
};

// Persisten layout
// Docs: https://inertiajs.com/pages#persistent-layouts
ItemPurchased.layout = page => <UserLayout children={page} header={'Items Purchased'} />;

export default ItemPurchased;
